import {createStyles, Theme} from "@material-ui/core";
import {buttonContainedLarge, buttonOutlinedLarge, greyInput, styleColors} from "src/main.style";

export const FamilyStyle = (theme: Theme) => createStyles({
  buttonOutlinedLarge,
  buttonContainedLarge,
  greyInput,
  dropBox : {
    fontSize: '16px',
    fontWeight: 400,
    letterSpacing: '0.00938em',
    backgroundColor: styleColors.white,
    border: `1px solid ${styleColors.greyMedium1}`,
    borderRadius: '4px',
    padding: '18.5px 14px',
  },

});




// WEBPACK FOOTER //
// ./src/components/extended-family/update-family-member/Family.style.ts